export default __webpack_public_path__ + "static/media/no_related_doctor.12f5dec4.png";